import Modal from "../General/Modal"

const TipInfoModal = ({setShowTipInfoModal}: {setShowTipInfoModal: (show: boolean) => void}) => {

  // const headingClass = "text-center bg-my-olive text-white text-md uppercase p-2 border border-my-grey border-b-0"
  // const subHeadingClass = "text-left bg-my-olive text-white capitalize p-1 border border-my-grey font-normal"
  // const cellClass = "p-1 border border-my-grey text-left"

  return <Modal
    closeFunction={() => setShowTipInfoModal(false)}
    title="Allow Tipping?"
  >
    <>
      <p className="py-2 text-left">Flossi apply small service / convenience fees to each payment.</p>

      <p className="py-2 text-left">When a jar is set to 'Jar Owner Pays Fees', the jar owner can <span className="font-bold">choose</span> to allow the contributor to optionally cover the fees as a tip. Note, leaving a tip is entirely optional.</p>

      <p className="py-2 text-left">The following £10 payment example presents the two tip options.</p>

      <h1 className="underline text-left font-bold">No Tip Added</h1>
      <p className="text-left">
        The fees are taken from the total contribution amount and are therefore paid for by the jar owner.
      </p>
      <ul className="text-left py-2 list-disc list-inside">
        <li>Contributor Pays: £10.00</li>
        <li>Jar Owner Receives: £9.70 <span className="text-sm">(£10.00 minus £0.30 fees)</span></li>
      </ul>
      <h1 className="underline text-left font-bold">Tip Added</h1>
      <p className="text-left">The fees are added to the contribution amount in the form of a tip and are therefore paid for by the contributor.</p>
      <ul className="text-left py-2 list-disc list-inside">
        <li>Contributor Pays: £10.30 <span className="text-sm">(£10.00 plus £0.30 tip)</span></li>
        <li>Jar Owner Receives: £10.00 <span className="text-sm">(£10.30 minus £0.30 fees)</span></li>
      </ul>
    </>
  </Modal>
}

export default TipInfoModal